import queryString from 'query-string'
import {
  ExecutionItemResponse,
  ExecutionItemResult,
  ExecutionResponse,
  PageResponse,
  ServiceSummaryResponse
} from 'src/dto'

import { gatewayApi } from '../instancias-api'

const URL_BASE = '/background-services'

/**
 * Calcula o intervalo [start, end) em UTC a partir do "hoje" local (Brasília),
 * cobrindo `dias` dias até o fim do dia local de hoje. O backend filtra por
 * `StartedAt >= start` e `< end`; enviar UTC explícito evita divergência de fuso
 * perto da meia-noite (ver doc §6.4).
 */
export const calcularPeriodoUtc = (
  dias: number
): { startDate: string; endDate: string } => {
  const agora = new Date()

  const inicioLocal = new Date(
    agora.getFullYear(),
    agora.getMonth(),
    agora.getDate() - (dias - 1),
    0,
    0,
    0,
    0
  )

  // fim exclusivo: início do dia seguinte local
  const fimLocal = new Date(
    agora.getFullYear(),
    agora.getMonth(),
    agora.getDate() + 1,
    0,
    0,
    0,
    0
  )

  return {
    startDate: inicioLocal.toISOString(),
    endDate: fimLocal.toISOString()
  }
}

/** Nível 1 — resumo (1 linha por serviço). Resposta é array direto, não paginada. */
export const ObterResumoServicos = async (
  startDate: string,
  endDate: string
): Promise<ServiceSummaryResponse[]> => {
  const filtros = queryString.stringify({ startDate, endDate })

  const { data } = await gatewayApi.get<ServiceSummaryResponse[]>(
    `${URL_BASE}/summary?${filtros}`
  )

  return data
}

/** Nível 2 — execuções paginadas de um serviço. */
export const ObterExecucoesServico = async (
  service: string,
  startDate: string,
  endDate: string,
  page: number,
  pageSize: number
): Promise<PageResponse<ExecutionResponse>> => {
  const filtros = queryString.stringify({
    service,
    startDate,
    endDate,
    page,
    pageSize
  })

  const { data } = await gatewayApi.get<PageResponse<ExecutionResponse>>(
    `${URL_BASE}/executions?${filtros}`
  )

  return data
}

/** Nível 3 — itens (parcelas) paginados de uma execução. */
export const ObterItensExecucao = async (
  executionId: string,
  result: ExecutionItemResult | undefined,
  studentName: string | undefined,
  page: number,
  pageSize: number
): Promise<PageResponse<ExecutionItemResponse>> => {
  const filtros = queryString.stringify({ result, studentName, page, pageSize })

  const { data } = await gatewayApi.get<PageResponse<ExecutionItemResponse>>(
    `${URL_BASE}/executions/${executionId}/items?${filtros}`
  )

  return data
}
